import React from "react"
import styles from "./styles.scss"
import { Button, TYPES, SIZES } from "components/Button"
import IconBox from "./IconBox"
import { Link } from "react-router-dom"
import { infoPagePath, contactPagePath } from "utils/paths"

class Footer extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.logo}>

          <img
            src={require("images/logo.png")}
            className={styles.logoImage}
          />
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.contentBox}>
            <h2 className={styles.title}> Sociala medier </h2>
            <div>
              <IconBox icon={["fab", "facebook-square"]}> <a href="https://www.facebook.com/" className={styles.iconText}>Facebook</a> </IconBox>
              <IconBox icon={["fab", "instagram"]} text="Instagram"> <a href="https://www.instagram.com/" className={styles.iconText}>Instagram</a> </IconBox>
            </div>
          </div>
          <div className={styles.contentBox}>
            <h2 className={styles.title}>Kontakta oss</h2>
            <div className={styles.listWrapper}>
              <IconBox icon={"envelope"}><a href="mailto:info@fixarfolket.se" className={styles.iconText}>info@fixarfolket.se</a> </IconBox>
              <IconBox icon={"phone"}><a href="tel:0793409745" className={styles.iconText}>079-340 97 45</a> </IconBox>
            </div>
          </div>
          <div className={styles.contentBox}>
            <h2 className={styles.title}>Om oss</h2>
            <div className={styles.listWrapper}>
              <p className={styles.aboutText}>
                &copy; Fixarfolket 2018. Fixarfolket är en sökmotor för att
                hitta företag i din kommun, enkelt & snabbt.
            </p>
            </div>
          </div>
          <div className={styles.contentBox}>
            <h2 className={styles.title}>För företag</h2>
            <Link to={infoPagePath()} >
              <Button
                buttonType={TYPES.DARK_GRAY}
                buttonSize={SIZES.LARGE}
                type="submit"
              >
                Lägg till företag
            </Button>
            </Link>
            <Link to={contactPagePath()}>
              <Button
                buttonType={TYPES.DARK_GRAY}
                buttonSize={SIZES.LARGE}
                type="submit"
              >
                Annonsera
            </Button>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
export default Footer



// WEBPACK FOOTER //
// src/components/Footer/index.jsx